import { css } from '@emotion/react';
import styled from '@emotion/styled';

import {
  Menu as BaseMenu,
  MenuDropdown as BaseMenuDropdown,
} from '@Calix-Commerce/design-system/components';

const INTERNAL_BORDER = '1px solid #c7c7c7';

const selectedOption = ({ theme }) => css`
  background: #ededed;

  span {
    color: ${theme.colors.secondary};
  }
`;

export const Title = styled.div`
  font-weight: bold;
`;

export const Menu = styled(BaseMenu)`
  width: 220px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const MenuDropdown = styled(BaseMenuDropdown)`
  width: 275px;
  padding: 1.07rem;

  & > svg {
    position: absolute;
    right: 0.7rem;
    top: 0.7rem;
    color: #666;
    font-size: 1.8rem;
    cursor: pointer;
    z-index: 1000;
  }
`;

export const MenuTotal = styled.div`
  margin-top: 0.4rem;
  font-weight: bold;
`;

export const Account = styled.div`
  position: relative;
  padding-bottom: 0.8rem;
  padding-right: ${({ showSettings }) => (showSettings ? '1.62rem' : '0')};
  border-bottom: ${INTERNAL_BORDER};
  margin-bottom: 0.5rem;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: normal;
  text-align: left;
`;

export const OptionStyled = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 3px 5px;
  font-weight: bold;
  border-radius: 0.29rem;

  span {
    flex-grow: 1;
    color: ${({ theme }) => theme.colors.action};
    text-align: left;
  }

  img {
    width: 50px;
    height: 50px;
    margin-right: 0.3rem;
  }

  & > svg {
    color: ${({ theme }) => theme.colors.action};
    font-size: 1.72rem;
    margin: 0px 6.5px;
  }

  &:hover {
    ${selectedOption};
  }

  ${({ selected }) => (selected ? selectedOption : '')};
`;

export const RmaItemListStyled = styled.div`
  max-height: 250px;
  overflow: auto;
`;

export const RmaDetailTitle = styled.div`
  border-top: ${INTERNAL_BORDER};
  border-bottom: ${INTERNAL_BORDER};
  margin: 1.2rem 0 0.8rem;
  padding: 0.1rem;
  padding-left: 1rem;
  color: ${({ theme }) => theme.colors.action};
  font-weight: bold;
  font-size: 1.1rem;
  cursor: pointer;
  text-align: left;
`;

export const RmaItem = styled.div`
  position: relative;
  width: 100%;
  background: #ededed;
  padding: 0.5rem 1rem;
  border-radius: 0.29rem;
  margin: 0.5rem 0;
  color: #000;

  & > svg {
    position: absolute;
    top: 0.15rem;
    right: 0.15rem;
    font-size: 1.25rem;
    color: ${({ theme }) => theme.colors.action};
    cursor: pointer;
  }
`;

export const SerialNumber = styled.div`
  color: ${({ theme }) => theme.colors.item};
  margin-bottom: 0.2rem;
  text-align: left;
`;

export const RmaInfo = styled.div`
  display: flex;
  justify-content: space-between;

  span {
    display: inline-block;
  }

  span:first-of-type {
    font-weight: bold;
  }
`;
